export const setLoadingTrue = () => {
  return {
    type: "SET_LOADING_TRUE",
  };
};

export const setLoadingFalse = () => {
  return {
    type: "SET_LOADING_FALSE",
  };
};
